<template>
  <SoAlert
    v-if="defaultNotice?.createdDate"
    class="mx-5 my-5"
    type="error"
    data-testid="default-notice-alert"
  >
    <SoRow>
      <SoCol :default-width="8">
        <h6>
          Pre-default notice sent
          {{ formatDate(defaultNotice?.createdDate) }}. Advise the customer that
          they can avoid a credit default and debt collection if they can make
          full or part payment.
        </h6>
      </SoCol>
      <SoCol :default-width="4" class="text-right">
        <SoButton
          title="Resolution guide"
          large
          data-testid="default-notice-resolution-guide"
          type="inverted"
          @click="openResolutionGuide()"
        />
      </SoCol>
    </SoRow>
  </SoAlert>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoAlert from "@/components/SoAlert.vue"
  import { formatDate } from "@/helpers/dateHelper"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import SoButton from "@/components/formControls/SoButton.vue"
  import SoCol from "@/components/SoCol.vue"
  import SoRow from "@/components/SoRow.vue"

  export default defineComponent({
    components: {
      SoAlert,
      SoButton,
      SoCol,
      SoRow,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
        formatDate,
      }
    },
    computed: {
      defaultNotice() {
        return this.current.preDefaultNotice.data
      },
    },
    methods: {
      openResolutionGuide() {
        window.open(
          "https://home.so.energy/posts/2119721-credit-reporting-defaults-process-explained",
        )
      },
    },
  })
</script>
